// EVERFLOW ENGAGEMENT EVENT
// to be called on page load and each route change
export default function (ctx) {
  if (process.browser) {
    if (ctx.route && ctx.route.path === '/banklookupiframe_') {
      console.log('[ef] is iframe');
      return;
    }

    if (!window.EF) {
      window.ef_click_on_load = true;
    } else {
      window.ef_click && window.ef_click();
    }
  }
}